export * from './lib/toggle-button.component';
